import { MonthlyExternalExpense } from '@/hooks/api/models';
import { useLoading } from '@/providers/LoadingProvider';
import { useEffect, useState } from 'react';
import { useCreateExternalExpense } from '@/hooks/api/2440_create_monthly_external_expense';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { toastError, toastSuccess } from '@/lib/toast';
import { InputPrice } from '@/components/element/Form/InputPrice';

type Props = {
  monthlyExternalExpense: MonthlyExternalExpense;
};
export const MonthlyExternalExpenseElement = ({ monthlyExternalExpense }: Props) => {
  const { setShowLoading } = useLoading();
  const { _w_, me } = useCurrentWorkspace();
  const [selected, setSelected] = useState<boolean>(false);
  const [amount, setAmount] = useState<string>(String(monthlyExternalExpense.amount));
  const { mutate, data, isPending, error } = useCreateExternalExpense();

  const onEditClick = () => {
    mutate({ identifier: _w_!.identifier, year_month: monthlyExternalExpense.year_month, amount: Number(amount) || 0 });
  };

  useEffect(() => setShowLoading(isPending), [isPending]);

  useEffect(() => {
    if (data) {
      monthlyExternalExpense.amount = data.amount;
      setSelected(false);
      toastSuccess('Node管理外費用を編集しました');
    }
  }, [data]);

  useEffect(() => {
    if (error) {
      const msgs: string[] = (error as any).response.data.errors || [];
      if (msgs.length > 0) toastError(msgs[0]);
    }
  }, [error]);

  return (
    <tr>
      <td className="text-xs text-dark">
        {String(monthlyExternalExpense.year_month)
          .match(/.{1,4}/g)
          ?.join('/')}
      </td>
      {selected ? (
        <>
          <td className="text-xs text-wrap">
            <div className="input-group">
              <InputPrice onChange={setAmount} classNames={'text-xs'} value={amount} />
            </div>
          </td>
          <td className="text-end">
            <button
              type="button"
              className="btn btn-icon-only btn-outline-secondary me-1"
              onClick={() => setSelected(false)}
            >
              <i className="fas fa-undo"></i>
            </button>
            <button type="button" className="btn btn-icon-only bg-gradient-dark" onClick={() => onEditClick()}>
              <i className="fas fa-check-circle"></i>
            </button>
          </td>
        </>
      ) : (
        <>
          <td className="text-xs text-dark text-end">¥{monthlyExternalExpense.amount.toLocaleString()}</td>
          <td className="text-end">
            <button type="button" className="btn btn-icon-only bg-gradient-success" onClick={() => setSelected(true)}>
              <i className="fas fa-edit"></i>
            </button>
          </td>
        </>
      )}
    </tr>
  );
};
